import { MenuControllerModule } from '@adaptiva/core/menus';
import { UserDashboardMenuController, UserDashboardSubscriptionMenuController } from '@adaptiva/dashboards/common';
import { ActionTreeMenuController, AdministratorMenuController, AllContentTreeMenuController, ClassPermissionsEditorMenuController, ClassPermissionsMenuController, ClassPermissionsMultiMenuController, ClassPermissionsTreeMenuController, ContentMenuController, ContentMultiMenuController, ContentPushPolicyMenuController, ContentTreeMenuController, DataProviderEditorMenuController, DataProviderMenuController, DataProviderTreeMenuController, DeviceMenuController, DeviceMultiMenuController, FolderPermissionsMenuController, GroupMenuController, GroupMultiMenuController, GroupsMultiTreeMenuController, GroupTreeMenuController, InventoryPolicyMenuController, ObjectPermissionsMenuController, OfficeMenuController, OfficeMultiMenuController, OfficeTreeMenuController, PolicyMenuController, PolicyMultiMenuController, RoleEditorMenuController, SensorActionExecutionPolicyMenuController, ServerObjectEditorMenuController, ServerObjectMenuController, ServerObjectMultiMenuController, ServerObjectTreeMenuController, ThemeEditorMenuController, ThemeMenuController } from '@adaptiva/data-service';
import { WebFormEditorMenuController } from '@adaptiva/forms/common';
import { SensorMenuController, SensorMultiMenuController } from '@adaptiva/server/menus';
import { WorkflowMenuController, WorkflowMultiMenuController, WorkflowTreeMenuController } from '@adaptiva/workflows/common';

export const ADMIN_PORTAL_MENU_CONTROLLERS: Partial<MenuControllerModule.Configuration> = {
	controllers: [
		ActionTreeMenuController,
		AdministratorMenuController,
		AllContentTreeMenuController,
		ClassPermissionsMenuController,
		ClassPermissionsEditorMenuController,
		ClassPermissionsMultiMenuController,
		ClassPermissionsTreeMenuController,
		ContentMenuController,
		ContentMultiMenuController,
		ContentPushPolicyMenuController,
		ContentTreeMenuController,
		DataProviderEditorMenuController,
		DataProviderMenuController,
		DataProviderTreeMenuController,
		DeviceMenuController,
		DeviceMultiMenuController,
		FolderPermissionsMenuController,
		GroupMenuController,
		GroupMultiMenuController,
		GroupsMultiTreeMenuController,
		GroupTreeMenuController,
		InventoryPolicyMenuController,
		ObjectPermissionsMenuController,
		OfficeMenuController,
		OfficeMultiMenuController,
		OfficeTreeMenuController,
		PolicyMenuController,
		PolicyMultiMenuController,
		RoleEditorMenuController,
		SensorActionExecutionPolicyMenuController,
		SensorMenuController,
		SensorMultiMenuController,
		ServerObjectEditorMenuController,
		ServerObjectMenuController,
		ServerObjectMultiMenuController,
		ServerObjectTreeMenuController,
		ThemeEditorMenuController,
		ThemeMenuController,
		UserDashboardMenuController,
		UserDashboardSubscriptionMenuController,
		WebFormEditorMenuController,
		WorkflowMenuController,
		WorkflowMultiMenuController,
		WorkflowTreeMenuController,
	]
};
